<template>
  <div
    class="stepper"
    id="scroll-to-top-section"
    :class="{ 'form-submitted': is_submitted }"
  >
    <div class="stepper-toolbar" v-if="currentStep < 4">
      <div class="stepper-toolbar-nav">
        <a
          :class="{
            'is-current': currentStep >= 1,
            'is-completed': currentStep > 1,
          }"
          @click.prevent="clickTab(1)"
        >
          <span>1</span>Info
        </a>
        <a
          :class="{
            'is-current': currentStep >= 2,
            'is-completed': currentStep > 2,
          }"
          @click.prevent="clickTab(2)"
        >
          <span>2</span>Questions
        </a>
        <a
          :class="{
            'is-current': currentStep >= 3,
            'is-completed': currentStep > 3,
          }"
          @click.prevent="clickTab(3)"
        >
          <span>3</span>Resume
        </a>
      </div>
    </div>
    <div class="stepper-body">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form @submit.prevent="handleSubmit(onSubmit)" class="info-form">
                <div
                  class="required-informations applicants-information-section"
                  v-if="currentStep == 1"
                >
                  <h2 class="h5">Required Information</h2>
                  <div class="row">
                    <div class="col-lg-12">
                      <!--                          :rules="{ 'image':true,'ext':'gif|jpg|jpeg|png|bmp','required':avatar_required }"-->
                      <keep-alive>
                        <validation-provider
                          name="avatar"
                          :rules="{ image: true, ext: 'gif|jpg|jpeg|png|bmp' }"
                          ref="avatar_file_provider"
                          tag="div"
                          class="file-upload-wrapper"
                          v-slot="{ validate, errors }"
                        >
                          <label for="upload-avater">
                            <div
                              class="avater-thumb"
                              :style="{
                                backgroundImage:
                                  'url(' + uploaded_image_url + ')',
                              }"
                            ></div>
                            <div class="upload-btn">
                              <i class="far fa-cloud-upload-alt"></i>
                              <span>Upload Picture</span>
                            </div>
                          </label>
                          <input
                            type="file"
                            id="upload-avater"
                            accept=".jpg, .jpeg, .png, .bmp, .gif"
                            ref="avatar_file"
                            :class="{ 'is-invalid': errors.length }"
                            @change="
                              validate($event);
                              handleAvatarChange($event);
                            "
                          />
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </validation-provider>
                      </keep-alive>
                    </div>
                    <div class="col-lg-6">
                      <ValidationProvider
                        vid="first_name"
                        name="Full Name"
                        rules="required|min:2|max:100"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="first_name">
                          Full Name:
                          <span class="required">*</span>
                        </label>
                        <input
                          id="first_name"
                          :class="{ 'input-error': errors.length }"
                          v-model="model.first_name"
                          placeholder="Full Name"
                          type="text"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                      <div class="col-lg-6">
                              <ValidationProvider
                                  vid="heard_about_us"
                                  name="Hear About Us"
                                  rules="numeric"
                                  v-slot="{ errors }"
                                  tag="div"
                                  class="select-wrapper d-flex flex-column h-100 input-wrapper">
                                  <label for="heard_about_us">
                                      How Did You Hear About Us?
                                  </label>
                                  <select
                                      v-model="model.heard_about_us"
                                      id="heard_about_us"
                                      :class="{ 'input-error': errors.length }"
                                  >
                                      <option value>Select One</option>
                                      <option v-for="(item, index) in heard_about_us" :key="index" :value="item.id">
                                          {{ item.name }}
                                      </option>
                                  </select>
                                  <div class="invalid-feedback">{{ errors[0] }}</div>
                              </ValidationProvider>
                      </div>
<!--                    <div class="col-lg-6">-->
<!--                      <ValidationProvider-->
<!--                        vid="last_name"-->
<!--                        name="Last Name"-->
<!--                        rules="max:100"-->
<!--                        v-slot="{ errors }"-->
<!--                        tag="div"-->
<!--                        class="input-wrapper"-->
<!--                      >-->
<!--                        <label for="last_name" class="sr-invisible"-->
<!--                          >Last Name</label-->
<!--                        >-->
<!--                        <input-->
<!--                          id="last_name"-->
<!--                          :class="{ 'input-error': errors.length }"-->
<!--                          v-model="model.last_name"-->
<!--                          placeholder="Your Last Name"-->
<!--                          type="text"-->
<!--                        />-->
<!--                        <div class="invalid-feedback">{{ errors[0] }}</div>-->
<!--                      </ValidationProvider>-->
<!--                    </div>-->

                    <div class="col-lg-6">
                      <ValidationProvider
                        vid="email"
                        name="Email Address"
                        rules="required|email|min:4|max:100"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="email_address">
                          Email:
                          <span class="required">*</span>
                        </label>
                        <input
                          :readonly="!!authStatus"
                          :disabled="!!authStatus"
                          id="email_address"
                          :class="{ 'input-error': errors.length }"
                          v-model="model.email"
                          @blur="verifyEmail"
                          placeholder="Your Email Address"
                          type="text"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-lg-6">
                      <ValidationProvider
                        vid="phone"
                        name="Phone"
                        :rules="{
                          required: true,
                          min: 5,
                          max: 15,
                          regex: /^[0-9+\-()\s]+$/,
                        }"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="phone_number">
                          Phone:
                          <span class="required">*</span>
                        </label>
                        <input
                          id="phone_number"
                          :class="{ 'input-error': errors.length }"
                          v-model="model.phone"
                          placeholder="Your Phone Number"
                          type="text"
                        />
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-lg-6" v-if="required_password">
                      <ValidationProvider
                        vid="password"
                        name="New Password"
                        rules="required|min:5|max:100"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="password">
                          New Password:
                          <span class="required">*</span>
                        </label>
                        <input
                          id="password"
                          :class="{ 'input-error': errors.length }"
                          v-model="model.password"
                          placeholder="Your Password"
                          :type="password_field_type1"
                        />
                        <i
                          class="far cooo"
                          :class="{
                            'fa-eye-slash': password_field_type1 == 'password',
                            'fa-eye': password_field_type1 == 'text',
                          }"
                          @click="togglePasswordEye1"
                        ></i>

                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>

                    <div class="col-lg-6" v-if="required_password">
                      <ValidationProvider
                        vid="password_confirmation"
                        name="Confirm Password"
                        rules="required|password_confirmation:@password"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="password">
                          Confirm Password:
                          <span class="required">*</span>
                        </label>
                        <input
                          id="password_confirmation"
                          :class="{ 'input-error': errors.length }"
                          v-model="model.password_confirmation"
                          placeholder="Confirm New Password"
                          :type="password_field_type2"
                        />
                        <i
                          class="far cooo"
                          :class="{
                            'fa-eye-slash': password_field_type2 == 'password',
                            'fa-eye': password_field_type2 == 'text',
                          }"
                          @click="togglePasswordEye2"
                        ></i>
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-lg-12" v-if="LoginIsRequired">
                      <ul class="global-invalid-feedback">
                        <li>
                            The email address is already registered. Please
                          <a
                            href="javascript:void(0)"
                             style="text-decoration: underline"
                            @click.prevent="showLoginModal = true"
                            >click here </a
                          >to log in and apply for the job.
                        </li>
<!--                          <li>-->
<!--                          The email address is already registered.-->
<!--                          <a-->
<!--                            href="javascript:void(0)"-->
<!--                            @click.prevent="showLoginModal = true"-->
<!--                            >Please login</a-->
<!--                          >-->
<!--                        </li>-->
                      </ul>
                    </div>
                    <div class="col-lg-12" v-if="model.logout_url">
                      <ul
                        class="global-invalid-feedback global-invalid-warning"
                      >
                        <li>
                          Incorrect email address?
                          <a :href="model.logout_url"
                            >Change email address here</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  class="required-informations job-information-section"
                  v-if="currentStep == 2"
                >
                  <h2 class="h5">Preliminary Questions</h2>
                  <div v-show="false">{{ questions }}</div>
                  <div
                    class="input-wrapper info-input-wrapper"
                    v-for="(item, index) in questions"
                    :key="index"
                  >
                    <div class="pre-question-item">
                      <ValidationProvider
                        :vid="'prequestion_' + index"
                        name="question"
                        v-if="item.answer_type == 1"
                        rules="required"
                        v-slot="{ errors }"
                        tag="div"
                      >
                        <h6 class="label">{{ item.question }}</h6>
                        <div
                          class="input-group"
                          :class="{ 'input-error': errors.length }"
                        >
                          <div class="custom-radio">
                            <input
                              type="radio"
                              @change="clickQuestionRadio(item, 2)"
                              v-model="item.radio"
                              :id="'reffered-by-0' + index"
                              :name="'reffered-by-' + item.id"
                              value="2"
                            />
                            <label :for="'reffered-by-0' + index">No</label>
                          </div>
                          <div class="custom-radio">
                            <input
                              type="radio"
                              @change="clickQuestionRadio(item, 1)"
                              v-model="item.radio"
                              :id="'reffered-by-1' + index"
                              :name="'reffered-by-' + item.id"
                              value="1"
                            />
                            <label :for="'reffered-by-1' + index">Yes</label>
                          </div>
                          <div class="feedback-error">{{ errors[0] }}</div>
                        </div>
                      </ValidationProvider>
                      <ValidationProvider
                        :name="'prequestion_' + index"
                        v-if="
                          (item.choose_option_type == 3 ||
                            item.answer_type == 2) &&
                          item.need_desc == 1
                        "
                        rules="required"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-group"
                      >
                        <textarea
                          v-model="item.textarea"
                          :class="{ 'input-error': errors.length }"
                          :placeholder="item.sub_question"
                        ></textarea>
                      </ValidationProvider>
                    </div>
                  </div>
                  <h2 class="h5">Applicant Information</h2>
                  <div class="row">
                    <div class="col-lg-6">
                      <div>
                        <ValidationProvider
                          vid="working_experience_year"
                          name="Work Experience"
                          rules="required"
                          v-slot="{ errors }"
                          tag="div"
                          class="select-wrapper select-wrapper-work-experience d-flex flex-column justify-content-end h-100 input-wrapper"
                        >
                          <label for="work-experience">
                            Work Experience (In Years):
                            <span class="required">*</span>
                          </label>
                          <select
                            v-model="model.working_experience_year"
                            id="work-experience"
                            :class="{ 'input-error': errors.length }"
                          >
                            <option value>Select Experience</option>
                            <option
                              v-for="(item, index) in work_years"
                              :key="index"
                              :value="index"
                            >
                              {{ item }}
                            </option>
                          </select>
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="col-lg-6">
                        <div>
                          <ValidationProvider
                            vid="notice_period_id"
                            name="Notice Period"
                            rules="required"
                            v-slot="{ errors }"
                            tag="div"
                            class="select-wrapper d-flex flex-column justify-content-end h-100 input-wrapper">
                            <label for="notice_period_id">
                                When Can You Join?
                              <span class="required">*</span>
                            </label>
                              <select
                                  v-model="model.notice_period_id"
                                  id="notice_period_id"
                                  :class="{ 'input-error': errors.length }"
                              >
                                  <option value>Select Notice Period</option>
                                  <option
                                      v-for="(item, index) in noticePeriods"
                                      :key="index"
                                      :value="item.id"
                                  >
                                      {{ item.name }}
                                  </option>
                              </select>
                            <div class="invalid-feedback">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-lg-6">
                      <ValidationProvider
                        vid="current_monthly_salary"
                        name="Current Salary"
                        rules="required|numeric|max:8"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="current-month-salary">
                          Current Salary:
                            <span class="required">*</span>
                        </label>
                        <div class="salary-wrapper">
                           <input
                          id="current-month-salary"
                          type="text"
                          placeholder=""
                          v-model="model.current_monthly_salary"
                          :class="{ 'input-error': errors.length }"
                        />
                          <span class="price-unit">BDT</span>
                        </div>

                      </ValidationProvider>
                    </div>
                    <div class="col-lg-6">
                      <ValidationProvider
                        vid="expected_monthly_salary"
                        name="Expected Salary"
                        rules="required|numeric|max:8"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="expected-month-salary">
                          Expected Salary:
                          <span class="required">*</span>
                        </label>
                         <div class="salary-wrapper">
                            <input
                              id="expected-month-salary"
                              type="text"
                              placeholder=""
                              v-model="model.expected_monthly_salary"
                              :class="{ 'input-error': errors.length }"
                            />
                             <span class="price-unit">BDT</span>
                         </div>

                      </ValidationProvider>
                    </div>
                    
                    <div class="col-lg-6">
                      <div>
                        <ValidationProvider
                          vid="educational_qualification_id"
                          name="Education"
                          rules="required|numeric"
                          v-slot="{ errors }"
                          tag="div"
                          class="select-wrapper d-flex flex-column justify-content-end h-100 input-wrapper"
                        >
                          <label for="education">
                            Education:
                            <span class="required">*</span>
                          </label>
                          <select
                            v-model="model.educational_qualification_id"
                            id="education"
                            :class="{ 'input-error': errors.length }"
                          >
                            <option value>Select Degree</option>
                            <option
                              v-for="(item, index) in educationQualifications"
                              :key="index"
                              :value="item.id"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                          <div class="invalid-feedback">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <ValidationProvider
                        vid="graduation_institute"
                        name="Graduation Institution"
                        rules="max:100"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="graduation-institution">
                          Graduation Institution:
                        </label>
                         <div class="salary-wrapper">
                            <input
                              id="graduation-institution"
                              type="text"
                              placeholder=""
                              v-model="model.graduation_institute"
                              :class="{ 'input-error': errors.length }"
                            />
                         </div>

                      </ValidationProvider>
                    </div>
                    <div class="col-lg-6">
                      <ValidationProvider
                        vid="current_company_name"
                        name="Current Company Name"
                        rules="max:100"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper"
                      >
                        <label for="current-company-name">
                          Current Company Name:
                        </label>
                         <div class="salary-wrapper">
                            <input
                              id="current-company-name"
                              type="text"
                              placeholder=""
                              v-model="model.current_company_name"
                              :class="{ 'input-error': errors.length }"
                            />
                         </div>

                      </ValidationProvider>
                    </div>
                    <div class="col-12">
                      <ValidationProvider
                        vid="briefly_experience"
                        name="Briefly Experience"
                        rules="max:3000"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper d-flex flex-column justify-content-end"
                      >
                        <label for="briefly-experience">
                          Briefly Explain Your Work Experience:
                        </label>
                        <textarea
                          v-model="model.briefly_experience"
                          id="briefly-experience"
                          placeholder=""
                          :class="{ 'input-error': errors.length }"
                          cols="30"
                          rows="7"
                          autocomplete="off"
                        ></textarea>
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-12">
                      <ValidationProvider
                        vid="portfolio_link"
                        name="portfolio link"
                        rules="url|max:191"
                        v-slot="{ errors }"
                        tag="div"
                        class="input-wrapper portfolio-lin-wrapper d-flex flex-column justify-content-end"
                      >
                        <label for="portfolio-link"> Portfolio Link: </label>
                        <input
                          v-model="model.portfolio_link"
                          type="text"
                          placeholder="Add your main portfolio link e.g., Dribbble, Behance, GitHub, personal website"
                          id="portfolio-link"
                          :class="{ 'input-error': errors.length }"
                          autocomplete="off"/>
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div class="col-12">
                      <ValidationProvider
                        vid="additional_comments"
                        name="Additional Comments"
                        rules="max:2000"
                        v-slot="{ errors }"
                        tag="div"
                        class="datepicker-wrapper input-wrapper d-flex flex-column justify-content-end"
                      >
                        <label for="additional-comments">
                          Additional Comments:
                        </label>
                        <textarea
                          v-model="model.additional_comments"
                          id="additional-comments"
                          placeholder="Write Comments"
                          :class="{ 'input-error': errors.length }"
                          cols="30"
                          rows="7"
                          autocomplete="off"
                        ></textarea>
                        <div class="invalid-feedback">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div
                  class="basic-informations step-three applicants-resume-information-section"
                  v-if="currentStep == 3"
                >
                  {{ model.resume }}
                  <validation-provider
                    vid="resume_file"
                    name="Resume File"
                    :rules="{
                      required: resume_required,
                      ext: 'pdf',
                      size: 5120,
                    }"
                    ref="resume_file_provider"
                    tag="div"
                    class="form-group input-wrapper"
                    v-slot="{ validate, errors }"
                  >
                    <h5 class="common-header">Upload Your Resume</h5>
                    <div
                      :class="{ 'file-error': errors.length }"
                      class="upload-common-wrapper text-center"
                      @drop.prevent="DropResumeFile"
                      @dragover.prevent
                    >
                      <strong class="m-b-10" v-if="!!resume_file_name">{{
                        resume_file_name
                      }}</strong>
                      <strong class="m-b-10" v-else
                        >Drag and drop files here or click Upload File.</strong
                      >
                      <span
                        class="upload-limitaion-title"
                        v-if="!resume_file_name"
                        >Max file size is (5Mb) and allowed file types is PDF</span
                      >
                      <span class="upload-limitaion-title" v-else
                        >File has been selected</span
                      >
                      <input
                        type="file"
                        accept=".pdf"
                        id="upload-resume-file"
                        ref="resume_file"
                        class="d-none"
                        :class="{ 'is-invalid': errors.length }"
                        @change="
                          validate($event);
                          handleResumeFileChange($event);
                        "
                      />
                      <label
                        for="upload-resume-file"
                        class="secondary-btn btn-small"
                        v-if="!resume_file_name"
                        >UPLOAD FILE</label
                      >
                      <label
                        for="upload-resume-file"
                        class="secondary-btn btn-small"
                        v-else
                        >CHANGE FILE</label
                      >
                      <div class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                  </validation-provider>

                  <!-- <validation-provider
                    vid="cover_letter_file"
                    name="Cover Letter File"
                    :rules="{
                      ext: 'pdf',
                      required: cover_letter_required,
                      size: 5120,
                    }"
                    ref="cover_letter_file_provider"
                    tag="div"
                    class="form-group input-wrapper"
                    v-slot="{ validate, errors }"
                  >
                    <h5 class="common-header">Cover Letter (Optional)</h5>
                    <div
                      :class="{ 'file-error': errors.length }"
                      class="upload-common-wrapper text-center"
                      @drop.prevent="DropCoverLetterFile"
                      @dragover.prevent
                    >
                      <strong class="m-b-10" v-if="!!cover_letter_file_name">{{
                        cover_letter_file_name
                      }}</strong>
                      <strong class="m-b-10" v-else
                        >Drag and drop files here or click Upload File.</strong
                      >
                      <span
                        class="upload-limitaion-title"
                        v-if="!cover_letter_file_name"
                        >Max file size is (5Mb) and allowed file type is PDF</span
                      >
                      <span class="upload-limitaion-title" v-else
                        >File has been selected</span
                      >
                      <input
                        type="file"
                        accept=".pdf"
                        id="upload-cover-letter"
                        ref="cover_letter_file"
                        class="d-none"
                        :class="{ 'is-invalid': errors.length }"
                        @change="
                          validate($event);
                          handleCoverLetterFileChange($event);
                        "
                      />
                      <label
                        for="upload-cover-letter"
                        class="secondary-btn btn-small"
                        v-if="!cover_letter_file_name"
                        >UPLOAD FILE</label
                      >
                      <label
                        for="upload-cover-letter"
                        class="secondary-btn btn-small"
                        v-else
                        >CHANGE FILE</label
                      >
                      <div class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                  </validation-provider> -->
                </div>

                <div
                  class="application-preview-section"
                  v-if="currentStep == 4"
                >
                  <h4 class="text-center m-b-20">Review Your Information</h4>
                  <div class="require-info">
                    <div class="common-header d-flex-center">
                      <h5 class="mr-auto">Required Information</h5>
                      <a href="#" class="btn-link" @click.prevent="goToStep(1)"
                        >Edit</a
                      >
                    </div>

                    <div
                      class="avatar-img big-avatar"
                      :style="{
                        backgroundImage: 'url(' + uploaded_image_url + ')',
                      }"
                    ></div>
                    <ul>
                      <li>{{ model.first_name }} {{ model.last_name }}</li>
                      <li>{{ model.email }}</li>
                      <li>{{ model.phone }}</li>
                      <li v-if="heard_about_us_text">{{ heard_about_us_text }}</li>
                    </ul>
                  </div>
                  <!-- End  .require-info -->

                  <div class="preliminary-question m-b-30">
                    <div class="common-header d-flex-center">
                      <h5 class="mr-auto">Preliminary Questions</h5>
                      <a href="#" class="btn-link" @click.prevent="goToStep(2)"
                        >Edit</a
                      >
                    </div>
                    <div class="preliminary-question-inner">
                      <div
                        class="preliminary-question-item"
                        v-for="(item, index) in questions"
                        :key="index"
                      >
                        <h6 v-if="item.question">{{ item.question }}</h6>
                        <div
                          v-if="
                            item.answer_type == 1 &&
                            item.choose_option_type == 1
                          "
                        >
                          <p v-if="item.radio == 1">Yes</p>
                          <p v-else>No</p>
                        </div>
                        <div
                          v-else-if="
                            item.answer_type == 1 &&
                            item.choose_option_type == 2
                          "
                        >
                          <p>{{ item.textarea }}</p>
                        </div>
                        <div
                          v-else-if="
                            item.answer_type == 1 &&
                            item.choose_option_type == 3
                          "
                        >
                          <p v-if="item.radio == 1 && item.need_desc == 1">
                            {{ item.textarea }}
                          </p>
                          <p v-else>No</p>
                        </div>
                        <div
                          v-else-if="
                            item.answer_type == 1 &&
                            item.choose_option_type == 4
                          "
                        >
                          <p v-if="item.radio == 1 && item.need_desc == 1">
                            Yes
                          </p>
                          <p v-else>{{ item.textarea }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End .preliminary-question -->
                  <div class="scedule-salary-info m-b-30">
                    <div class="common-header d-flex-center">
                      <h5 class="mr-auto">Schedule & Salary Information</h5>
                      <a href="#" class="btn-link" @click.prevent="goToStep(2)"
                        >Edit</a
                      >
                    </div>

                    <div class="scedule-salary-info-inner">
                      <div v-if="work_experience_text">
                        <h6>Working Experience(In Years):</h6>
                        <p>{{ work_experience_text }}</p>
                      </div>
                      <div v-if="model.notice_period_id">
                        <h6>When Can You Join?:</h6>
                        <p>{{ notice_period_text }}</p>
                      </div>
                      <div v-if="model.current_monthly_salary">
                        <h6>Current Salary:</h6>
                        <p>
                          <span>{{model.current_monthly_salary | filterAmount }} BDT</span>
                        </p>
                      </div>
                      <div v-if="model.expected_monthly_salary">
                        <h6>Expected Salary:</h6>
                        <p>
                          <span>{{model.expected_monthly_salary | filterAmount }} BDT</span>
                        </p>
                      </div>
                      <div v-if="educational_text">
                        <h6>Education:</h6>
                        <p>{{ educational_text }}</p>
                      </div>
                      <div v-if="model.graduation_institute">
                        <h6>Graduation Institute:</h6>
                        <p>{{ model.graduation_institute }}</p>
                      </div>
                      <div v-if="model.current_company_name">
                        <h6>Current Company Name:</h6>
                        <p>{{ model.current_company_name }}</p>
                      </div>
                      <div v-if="model.briefly_experience">
                        <h6>Work Experience Brief:</h6>
                        <nl2br tag="p" :text="model.briefly_experience"></nl2br>
                      </div>
                      <div v-if="model.portfolio_link">
                        <h6>Portfolio Link:</h6>
                        <p>
                          <a :href="model.portfolio_link" target="_blank">{{
                            model.portfolio_link
                          }}</a>
                        </p>
                      </div>
                      <div v-if="model.additional_comments">
                        <h6>Additional Comments:</h6>
                        <nl2br
                          tag="p"
                          :text="model.additional_comments"
                        ></nl2br>
                      </div>
                    </div>
                  </div>
                  <!-- End .scedule-salary-info -->
                  <div class="resume-signature m-b-30">
                    <div class="common-header d-flex-center">
                      <h5 class="mr-auto">Resume and Cover Letter</h5>
                      <a href="#" class="btn-link" @click.prevent="goToStep(3)"
                        >Edit</a
                      >
                    </div>

                    <div class="resume-info m-b-20">
                      <h6 class="color-typo-light m-b-15">Resume</h6>
                      <div class="d-flex-center">
                        <img
                          :src="
                            '/backend/assets/images/' +
                            getFileExt(resume_file_name) +
                            '.png'
                          "
                          class="cv-image"
                          alt="pdf image"
                        />
                        <span>{{ resume_file_name }}</span>
                      </div>
                    </div>
                    <div
                      class="resume-info m-b-20"
                      v-if="cover_letter_file_name"
                    >
                      <h6 class="color-typo-light m-b-15">Cover Letter</h6>
                      <div class="d-flex-center">
                        <img
                          :src="
                            '/backend/assets/images/' +
                            getFileExt(cover_letter_file_name) +
                            '.png'
                          "
                          class="cv-image"
                          alt="pdf image"
                        />
                        <span>{{ cover_letter_file_name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="basic-informations" v-if="currentStep < 5">
                  <validation-provider
                    vid="term"
                    v-if="currentStep == 4"
                    rules="required"
                    tag="div"
                    v-slot="{ errors }"
                  >
                    <div
                      class="custom-checkbox m-b-30 col-12 p-0"
                      :class="{ 'make-terms-checked': errors.length }"
                    >
                      <input
                        type="checkbox"
                        :value="1"
                        v-model="model.term"
                        id="terms"
                        :class="{ 'input-error': errors.length }"
                      />
                      <label for="terms"
                        >I agree that all the information provided is true and
                        accurate.</label
                      >
                      <ul
                        class="global-invalid-feedback feedback-checkbox"
                        v-if="errors.length"
                      >
                        <li>In order to apply, you must check the box.</li>
                      </ul>
                    </div>
                  </validation-provider>
                </div>
                  <div v-if="Object.keys(server_errors).length">
                      <ul class="global-invalid-feedback">
                          <li v-for="(item, index) in server_errors">{{ item[0] }}</li>
                      </ul>
                      <br>
                  </div>
                <div class="button-group">
                  <button
                    class="secondary-btn btn-mid"
                    v-if="currentStep > 1"
                    type="button"
                    @click="goToStep(currentStep - 1)"
                  >
                    Go Back
                  </button>
                  <button
                    v-if="!LoginIsRequired"
                    class="primary-btn btn-mid"
                    :disabled="!email_is_verified"
                    type="submit"
                  >
                    {{ currentStep === 4 ? "Submit Now" : "Continue" }}
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <login-modal :EventshowModal="showLoginModal"></login-modal>
  </div>
</template>
<script>
const Swal = require("sweetalert2");
// import Datepicker from "vuejs-datepicker";
import Nl2br from "vue-nl2br";
import LoginModal from "@axilAclVueSrc/components/LoginModal";

export default {
  props: {
    authStatus: { type: Number, default: false },
    educationQualifications: { type: Array, required: true },
    noticePeriods: { type: Array, required: true },
    salaryTypes: { type: Array, required: true },
    preQuestions: { type: Array, required: true },
    heardAboutUs: { type: Array, required: true },
    workYears: { type: Object, required: true },
    postJobUrl: { type: String, required: true },
    emailVerifyUrl: { type: String, required: true },
    fileVerifyUrl: { type: String, required: true },
    userdata: { type: Object },
  },
  data() {
    return {
      server_errors:{},
      showLoginModal: false,
      password_field_type1: "password",
      password_field_type2: "password",
      LoginIsRequired: false,

      required_password: true,
      is_submitted: false,
      currentStep: 1,
      questions: {},
      heard_about_us: [],
      work_years: [],
      salary_range_text: "",
      notice_period_text: "",
      work_experience_text: "",
      heard_about_us_text: "",
      model: {},
      available_date: "",
      avatar: null,
      uploaded_image_url: "/images/avatar.svg",
      avatar_required: true,
      salary_type_name: "",
      educational_text: "",
      graduation_institute: "",
      current_company_name: "",

      resume: null,
      resume_file_name: "",
      resume_required: true,

      cover_letter: null,
      cover_letter_file_name: "",
      cover_letter_required: false,

      signature_pad: "",
      signature_file: null,
      signature_file_url: "",
      signature_file_required: true,
      signature_pad_required: true,

      email_is_verified: true,
      deadline_disabledDates: {
      to: new Date(Date.now() - 8640000),
      },
    };
  },
  watch: {
    authStatus: {
      handler: function (val) {
        this.LoginIsRequired = false;
        if (val == 1) {
          this.required_password = false;
        } else {
          this.required_password = true;
        }
      },
      immediate: true,
    },
    'model': {
      handler: function (val) {
          this.server_errors = {}
      },
      immediate: true,
      deep: true
    },
    preQuestions: {
      handler: function (data) {
        this.questions = data;
      },
      immediate: true,
    },
    heardAboutUs: {
      handler: function (data) {
        this.heard_about_us = data;
      },
      immediate: true,
    },
    workYears: {
      handler: function (data) {
        this.work_years = data;
      },
      immediate: true,
    },
    userdata: {
      handler: function (data) {
        this.model = data;
        if (data.avatar) {
          this.uploaded_image_url = data.avatar;
          this.avatar_required = false;
        }
      },
      immediate: true,
    },
    "model.salary_type": function (newVal) {
      this.salary_type_name = this.getSelectTextValue(this.salaryTypes, newVal);
    },
    "model.educational_qualification_id": function (newVal) {
      this.educational_text = this.getSelectTextValue(
        this.educationQualifications,
        newVal
      );
    },
    "model.notice_period_id": function (newVal) {
      this.notice_period_text = this.getSelectTextValue(
        this.noticePeriods,
        newVal
      );
    },
    "model.working_experience_year": function (newVal) {
      if (this.work_years[newVal]) {
        this.work_experience_text = this.work_years[newVal];
      } else {
        this.work_experience_text = "";
      }
    },
    "model.heard_about_us": function (newVal) {
          this.heard_about_us_text = this.getSelectTextValue(this.heard_about_us, newVal);
      },
    "model.portfolio_link": function (newVal) {
      if (newVal.length > 4){
          if(newVal){
              newVal = newVal.indexOf("http") > -1 ? newVal : location.protocol + "//" + newVal;
          }
      }
      this.model.portfolio_link = newVal;
    },
  },
  mounted() {
    this.salary_type_name = this.getSelectTextValue(this.salaryTypes, 1);
  },
  methods: {
    previewDateFormat(date) {
      if (typeof date == "undefined") {
        return;
      }
      var dt = new Date(date);
      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();

      var fulldate = day + "/" + month + "/" + year;
      return fulldate;
    },
    dateFormat(date) {
      if (typeof date == "undefined") {
        return;
      }
      var dt = new Date(date);
      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();

      return year + "-" + month + "-" + day;
    },
    async handleAvatarChange(e) {
      const { valid } = await this.$refs.avatar_file_provider.validate(e);
      if (valid) {
        this.avatar = e.target.files[0];
        this.uploaded_image_url = URL.createObjectURL(this.avatar);
        this.avatar_required = false;
      }
    },
    async handleResumeFileChange(e) {
      const { valid } = await this.$refs.resume_file_provider.validate(e);
      if (valid) {
        this.verifyResumesFile(e.target.files[0]);
      } else {
        this.resume = "";
        this.resume_file_name = "";
        this.resume_required = true;
      }
    },

    removeResumeFile(e) {
      // this.$refs.resume_file_provider.reset();
      // this.resume = "";
      // this.resume_file_name = "";
      // this.resume_required = true;
      // this.$refs.resume_file.value = "";
      // this.$refs.resume_file.type = "text";
      // this.$refs.resume_file.type = "file";
      // this.$refs.resume_file.reset();
    },
    DropResumeFile: function (e) {
      var droppedFiles = e.dataTransfer.files;
      this.verifyResumesFile(droppedFiles[0]);
    },
    verifyResumesFile: function (file) {
      var formData = new FormData();
      formData.append("_rules", "file|max:5120|mimes:pdf");
      formData.append("field_name", "resume_file");
      formData.append("resume_file", file);

      var _this = this;
      this.is_submitted = true;
      axios
        .post(this.fileVerifyUrl, formData)
        .then((response) => {
          this.resume = response.data.file;
          this.resume_file_name = response.data.name;
          this.resume_required = false;
          this.$refs.resume_file_provider.reset();
        })
        .catch((error) => {
          this.resume_required = true;
          if (error.response.status == 422) {
            this.$refs.form.setErrors(error.response.data.errors);
          } else {
            this.$throwSwalError(error);
          }
        })
        .then(function () {
          _this.is_submitted = false;
        });
    },
    async handleCoverLetterFileChange(e) {
      const { valid } = await this.$refs.cover_letter_file_provider.validate(e);
      if (valid) {
        this.verifyCoverLetterFile(e.target.files[0]);
      } else {
        this.cover_letter = "";
        this.cover_letter_file_name = "";
        // this.cover_letter_required = true;
      }
    },
    removeCoverLetterFile(e) {
      // this.cover_letter = "";
      // this.cover_letter_file_name = "";
      // this.$refs.cover_letter_file.value = null;
      // this.cover_letter_required = true;
    },
    DropCoverLetterFile: function (e) {
      var droppedFiles = e.dataTransfer.files;
      this.verifyCoverLetterFile(droppedFiles[0]);
    },
    verifyCoverLetterFile: function (file) {
      var formData = new FormData();
      formData.append("_rules", "file|max:5120|mimes:pdf");
      formData.append("field_name", "cover_letter_file");
      formData.append("cover_letter_file", file);

      var _this = this;
      this.is_submitted = true;
      axios
        .post(this.fileVerifyUrl, formData)
        .then((response) => {
          this.cover_letter = response.data.file;
          this.cover_letter_file_name = response.data.name;
          // this.cover_letter_required = false;
          this.$refs.cover_letter_file_provider.reset();
        })
        .catch((error) => {
          // this.cover_letter_required = true;
          if (error.response.status == 422) {
            this.$refs.form.setErrors(error.response.data.errors);
          } else {
            this.$throwSwalError(error);
          }
        })
        .then(function () {
          _this.is_submitted = false;
        });
    },
    async handleSignatureFileChange(e) {
      const { valid } = await this.$refs.signature_file_provider.validate(e);
      if (valid) {
        this.verifySignatureFile(e.target.files[0]);
      } else {
        this.signature_file = "";
        this.signature_file_url = "";
      }
    },
    removeSignatureFile(e) {
      this.signature_file = "";
      this.signature_file_url = "";
      this.validateSignature(3);
    },

    DropSignatureFile: function (e) {
      var droppedFiles = e.dataTransfer.files;
      this.verifySignatureFile(droppedFiles[0]);
    },
    verifySignatureFile: function (file) {
      var formData = new FormData();
      formData.append("_rules", "file|max:1024|mimes:jpeg,png,bmp,gif");
      formData.append("field_name", "signature_file");
      formData.append("signature_file", file);

      var _this = this;
      this.is_submitted = true;
      axios
        .post(this.fileVerifyUrl, formData)
        .then((response) => {
          this.signature_file = file;
          this.signature_file_url = URL.createObjectURL(this.signature_file);
          this.signature_file_required = false;
          this.signature_pad_required = true;
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.$refs.form.setErrors(error.response.data.errors);
          } else {
            this.showModal = false;
            this.$throwSwalError(error);
          }
        })
        .then(function () {
          _this.is_submitted = false;
        });
    },
    goToStep(step) {
      if (step < 1) {
        return;
      }

      // this.validateSignature(step);
      var self = this;

      this.scrollToTop();
      console.log("go to step callded");
      if (step < this.currentStep) {
        this.currentStep = step;
        setTimeout(function () {
          if (_.size(self.server_errors)) {
            self.$refs.form.setErrors(self.server_errors);
          }
        }, 200);
      } else {
        if (step == 4) {
          this.onSubmit();
          return;
        }
      }
    },
    onSubmit() {
      if (this.currentStep === 4) {
        var formData = new FormData();
        var modelObj = Object.keys(this.model);
        modelObj.map((fieldName) => {
          let value = this.model[fieldName];
          formData.append(fieldName, value);
        });

        if (this.avatar) {
          formData.append("applicant_avatar", this.avatar);
        }
        formData.set(
          "available_date",
          this.dateFormat(this.model.available_date, "YYYY-MM-DD")
        );

        if (this.resume) {
          formData.append("resume_file", this.resume);
        }

        if (this.cover_letter) {
          formData.append("cover_letter_file", this.cover_letter);
        }

        if (this.signature_file) {
          formData.append("signature_file", this.signature_file);
        }

        if (this.signature_pad) {
          formData.append("signature_pad", this.signature_pad);
        }

        if (this.questions) {
          formData.append("questions", JSON.stringify(this.questions));
        }

        var _this = this;
        this.is_submitted = true;
        axios
          .post(this.postJobUrl, formData)
          .then((response) => {
            window.location.href = response.data.thanks;
            this.server_errors = {};
          })
          .catch((error) => {
            // return false;
            this.is_submitted = false;
            if (error.response.status == 422) {
              this.errors = error.response.data.errors;
              this.server_errors = error.response.data.errors;
              this.error_message = error.response.data.message;
              this.$refs.form.setErrors(error.response.data.errors);
            } else {
              this.showModal = false;
              this.$throwSwalError(error);
              this.error_message = "Something wrong at form!";
            }
          })
          .then(function () {
            _this.is_submitted = false;
          });
      } else {
        if (this.resume) {
          this.resume_required = false;
        }
        // if (_.isObject(this.cover_letter)) {
        //   this.cover_letter_required = false;
        // }
        this.currentStep++;
        // this.validateSignature(this.currentStep);
        this.scrollToTop();
      }
    },
    scrollToTop: function () {
      this.$scrollTo("#scroll-to-top-section");
    },
    onClickSignature: function () {
      if (this.model.signature_type == 1) {
        this.clearSignaturePad();
        this.signature_pad_required = true;
      } else {
        this.$refs.signature_file.value = null;
        this.signature_file = "";
        this.signature_file_url = "";
        this.signature_file_required = true;
      }
      this.validateSignature(3);
    },
    validateSignature(step) {
      var self = this;
      var nowCounter = 0;
      var refreshId = setInterval(
        function () {
          nowCounter = nowCounter + 100;
          if (nowCounter > 2000) {
            clearInterval(refreshId);
          }
          var isSignatured = self.updateSignaturePad();
          if (isSignatured) {
            clearInterval(refreshId);
          }
        },
        100,
        nowCounter
      );
      if (this.model.signature_type == 1) {
        this.signature_file_required = true;
        if (!this.signature_pad) {
          this.signature_pad_required = true;
        } else {
          this.signature_pad_required = false;
        }
      } else {
        this.signature_pad_required = true;
        if (typeof this.signature_file.name == "string") {
          this.signature_file_required = false;
        } else {
          this.signature_file_required = true;
        }
      }
    },
    undoSignaturePad() {
      this.$refs.signaturePad.undoSignature();
    },
    clearSignaturePad() {
      if (typeof this.$refs.signaturePad != "undefined") {
        this.$refs.signaturePad.clearSignature();
      }
      this.signature_pad = "";
      this.signature_file_required = true;
      this.signature_pad_required = true;
    },
    updateSignaturePad() {
      if (typeof this.$refs.signaturePad != "undefined") {
        if (this.signature_pad) {
          this.$refs.signaturePad.fromDataURL(this.signature_pad);
          return true;
        }
      }
    },
    saveSignaturePad() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      this.signature_file_required = true;
      if (isEmpty) {
        this.signature_pad_required = true;
      } else {
        this.signature_pad_required = false;
        this.signature_pad = data;
      }
    },
    onBegin() {
      // console.log('=== Begin ===');
    },
    onEnd() {
      this.signature_pad_required = false;
      this.signature_file_required = true;
      this.saveSignaturePad();
    },
    clickTab: function (step) {
      if (this.currentStep >= 4) {
        return false;
      } else if (this.currentStep > step) {
        this.currentStep = step;
      }
    },
    getSelectTextValue: function (options, val) {
      if (_.size(options)) {
        var data = _.filter(options, { id: parseInt(val) });

        if (data[0]) {
          data = data[0];
          return data[key];
        }
      }
      return "";
    },
    clickQuestionRadio: function (item, radio) {
      if (radio == 1) {
        item.radio = 1;
        item.need_desc = 1;
      } else {
        item.radio = 2;
        item.need_desc = 0;
      }
    },
    verifyEmail: function () {
      if (this.model.email) {
        this.email_is_verified = false;
        var params = { email: this.model.email };
        this.is_submitted = true;
        var _this = this;
        axios
          .post(this.emailVerifyUrl, params)
          .then((response) => {
            this.email_is_verified = true;
            this.required_password = true;
            this.LoginIsRequired = false;
            this.server_errors = {};
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status == 422) {
              this.required_password = false;
              this.LoginIsRequired = true;
              this.server_errors = error.response.data.errors;
              this.error_message = error.response.data.message;
              this.$refs.form.setErrors(error.response.data.errors);
            } else {
              this.showModal = false;
              this.$throwSwalError(error);
            }
          })
          .then(function () {
            _this.is_submitted = false;
          });
      }
    },
    getSelectTextValue: function (options, val, key = "name") {
      if (_.size(options)) {
        var data = _.filter(options, { id: parseInt(val) });

        if (data[0]) {
          data = data[0];
          return data[key];
        }
      }
      return "";
    },
    togglePasswordEye1: function (e) {
      if (this.password_field_type1 == "password") {
        this.password_field_type1 = "text";
      } else {
        this.password_field_type1 = "password";
      }
    },
    togglePasswordEye2: function (e) {
      if (this.password_field_type2 == "password") {
        this.password_field_type2 = "text";
      } else {
        this.password_field_type2 = "password";
      }
    },
    getFileExt: function (file) {
      if (file) {
        var ext = file.split(".").pop();
        if (ext) {
          return ext.toLowerCase();
        }
      }
    },
  },
  components: {
    Nl2br,
    LoginModal,
  },
};
</script>

<style lang="scss">
h1,
h2,
h2,
h4,
h5,
h6,
.h1,
.h2,
.h2,
.h4,
.h5,
.h6 {
  font-weight: 500;
}
a {
  color: var(--typo-para);
}
body {
  font-size: 1.6rem;
  line-height: 2.6rem;
}
.m-b-30 {
  margin-bottom: 30px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.m-b-10 {
  margin-bottom: 10px;
}
.color-primary {
  color: var(--primary-color);
}
.border-bottom {
  border-bottom: 0.1rem solid var(--border-color);
}
.common-header {
  padding-bottom: 1.5rem;
  margin-bottom: 2rem;
  border-bottom: 0.1rem solid var(--border-color);
  .btn-link {
    margin-top: 0;
  }
}
.cv-title {
  color: var(--primary-color);
}
.flex-column-direction {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.button-group button:not(:nth-last-of-type(1)) {
  margin-right: 20px;
}
.d-flex-center {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
img {
  max-width: 100%;
}
a,
button {
  &.disabled {
    opacity: 0.7;
  }
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  // transform: translateY(10%);
}
.make-terms-checked {
  input[type="checkbox"] ~ label::before {
    border-color: var(--input-error);
  }
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.25s;
}
.pagination {
  margin-bottom: 0;
  li {
    border-radius: 100%;
    border-width: 0.2rem;
    margin-right: 1rem;
    margin-bottom: 0.5rem;
    &:not(:nth-last-of-type(1)) {
      border-right-width: 0.2rem;
    }
    &:first-child,
    &:last-child {
      border-radius: 100%;
    }
    &.dots {
      border: none;
    }
  }
  a {
    min-width: 3rem;
    height: 3rem;
    font-size: 1.4rem;
    line-height: 3.1rem;
    padding: 0 0.5rem;
  }
}
label,
.label {
  font-size: 1.5rem;
  line-height: 2.4rem;
  color: var(--typo-heading);
  font-weight: 500;
  margin-bottom: 1rem;
}
.stepper-body {
  padding-bottom: 4rem;
}
.stepper-title {
  color: var(--primary-color);
  margin-bottom: 4rem;
}
.signature-controls {
  padding-top: 10px;
}
.stepper-body {
  h2 {
    padding-bottom: 2rem;
    margin-bottom: 3rem;
    border-bottom: 0.1rem solid var(--border-color);
  }
  .input-wrapper {
    margin-bottom: 2rem;
    i.cooo {
      pointer-events: all;
      cursor: pointer;
      top: 3.2rem;
    }
  }
  //   .info-form {
  //     padding-right: 210px;
  //     @media (max-width: 1199px) {
  //       padding-right: 0;
  //     }
  //   }
}
.info-form {
  button {
    margin-top: 0.5rem;
  }
}
.stepper-body {
  .datepicker-wrapper {
    position: relative;
    i {
      position: absolute;
      top: 0;
      font-size: 1.4rem;
      line-height: 4.6rem;
      pointer-events: none;
    }
    input {
      cursor: pointer;
    }
  }
  .select-wrapper {
    &::after {
      top: 3.2rem;
    }
  }
  option {
    color: var(--typo-para);
  }
  .devider {
    display: inline-block;
    position: absolute;
    left: 123px;
    top: 43px;
    @media (max-width: 1199px) {
      left: 94px;
    }
    @media (max-width: 991px) {
      display: none;
    }
  }
  .button-group button:not(:nth-last-of-type(1)) {
    margin-right: 20px;
  }
  .vdp-datepicker__calendar {
    top: 46px;
  }
}
.brand-logo {
  width: 18rem;
  max-width: 100%;
}
.sr-invisible {
  visibility: hidden;
  @media (max-width: 991px) {
    display: none;
  }
}
.input-group {
  .custom-radio,
  .custom-checkbox {
    &:not(:last-child) {
      margin-right: 3rem;
    }
  }
}
.info-input-wrapper {
  margin-bottom: 1rem;
}
.upload-common-wrapper {
  position: relative;
  &.signatur-common-wrapper {
    padding: 0 !important;
  }
  label {
    margin: 2rem 0 0;
  }
}
</style>
<style lang="scss" scoped>
#app {
  font-family: var(--primary-font);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--typo-para);
  box-sizing: border-box;
  min-height: calc(100vh - 80px);
}

.main {
  min-height: calc(100vh - 20rem);
}
.stepper {
  padding-top: 4rem;
}
.stepper-toolbar-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
  a {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 1.6rem;
    padding: 0 4.5rem;

    @media (max-width: 767px) {
      padding: 0 2.5rem;
    }
    &:not(:last-child) {
      &::before,
      &::after {
        content: " ";
        position: absolute;
        top: 2rem;
        left: 50%;
        width: 100%;
        border-top: 2px solid var(--border-color);
        z-index: 1;
      }

      &::after {
        width: 0;
        transition: width 0.3s;
        border-color: var(--primary-color);
      }
    }
    span {
      position: relative;
      z-index: 2;
      display: block;
      width: 4rem;
      height: 4rem;
      font-size: 1.6rem;
      line-height: 4rem;
      text-align: center;
      color: var(--typo-para);
      font-weight: 500;
      border-radius: 100%;
      background: var(--border-color);
      margin-bottom: 1rem;
      transition: all 0.5s;
    }

    &.is-current,
    &.is-completed {
      color: var(--primary-color);
      span {
        background: var(--primary-color);
        color: #fff;
      }
    }

    &.is-completed {
      &::after {
        width: 100%;
      }
    }

    &.disabled {
      opacity: 1;
    }

    &:hover {
      text-decoration: none;
    }
  }
}
.step-three {
  .form-group {
    margin-bottom: 30px;
    &.signature-wrapper {
      margin-bottom: 2rem;
    }
  }
  .upload-common-wrapper {
    border: 2px dashed var(--border-color);
    padding: 40px;
    strong {
      font-size: 1.6rem;
      line-height: 2.4rem;
      display: block;
    }
    .upload-limitaion-title,
    span {
      font-size: 1.4rem;
      line-height: 2.2rem;
      color: var(--typo-light);
      display: block;
    }

    &.file-error {
      border-color: var(--input-error);
    }
    &.signatur-common-wrapper {
      border: none;
      .draw-signature,
      .upload-signature {
        border: 2px dashed var(--border-color);
        &.file-error {
          border-color: var(--input-error);
        }
      }
    }
  }
}
.upload-signature {
  padding: 40px;
}
.draw-signature {
  padding: 20px 20px 10px 20px;
}
.draw-sign-title {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 3;
}
.signature-controls {
  position: absolute;
  padding: 0;
  bottom: 15px;
  right: 20px;
  z-index: 3;
}
.comfortable-salary-range {
  .row {
    margin-left: -7px;
    margin-right: -7px;
    @media (max-width: 991px) {
      margin-left: -15px;
      margin-right: -15px;
    }
    [class*="col"] {
      padding: 0 7px;
      @media (max-width: 991px) {
        padding: 0 15px !important;
      }
    }
    .select-wrapper::after {
      top: 0;
    }
  }
  .col-lg-3 {
    -ms-flex: 0 0 29%;
    flex: 0 0 29%;
    max-width: 29%;
    @media (max-width: 991px) {
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
}
.file-upload-wrapper {
  margin-bottom: 2rem;
  label {
    display: inline-flex;
    align-items: center;
    margin-bottom: 0;
    cursor: pointer;
    &:hover {
      .upload-btn {
        color: var(--action-color);
      }
    }
  }
  input {
    opacity: 0;
    position: absolute;
    left: -999999px;
  }
  .avater-thumb {
    width: 15rem;
    height: 15rem;
    border-radius: 100%;
    background-color: #d3d3d3;
    margin-right: 1rem;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    @media (max-width: 767px) {
      height: 10rem;
      width: 10rem;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .upload-btn {
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: #4d4d4d;
    transition: all 0.5s;
    span {
      text-decoration: underline;
    }
    i {
      margin-right: 0.5rem;
    }
  }
}

.upload-signature img {
  max-width: 120px;
  height: auto;
  margin-bottom: 10px;
}
.signature-info img {
  max-width: 173px;
  height: auto;
}
.signatur-common-wrapper {
  margin-bottom: 20px;
}
.application-preview-section {
  ul li,
  ol li {
    margin-bottom: 1rem;
  }
  ul {
    padding-left: 0;
    margin-bottom: 2rem;
    li {
      font-size: 1.6rem;
      line-height: 2.6rem;
      &::after {
        display: none;
      }
    }
  }
  h6 {
    margin-bottom: 1rem;
    color: var(--typo-light);
  }
  .resume-info {
    span {
      padding-left: 7px;
    }
  }
}
.avatar-img {
  height: 15rem;
  width: 15rem;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;

  @media (max-width: 767px) {
    height: 10rem;
    width: 10rem;
  }
}
input:required {
  box-shadow: 4px 4px 20px rgba(200, 0, 0, 0.85);
}
.salary-wrapper {
  position: relative;
    input {
        padding-right: 60px;
    }
  .price-unit {
      position: absolute;
      font-size: 15px;
      right: 20px;
      top: 10px;
      color: #b3b3b3;
  }
}

.portfolio-lin-wrapper .input-error ~ .invalid-feedback,
.portfolio-lin-wrapper .invalid-feedback
{
    display: block;
}

.feedback-error{
  text-align: left;
  display: block;
  color: #dc3545;
  font-size: 12px;
  width: 100%;
}
</style>

